import React from 'react';
import { Icon } from '@fourthwall/components';
import { ExclamationMarkIcon } from '@fourthwall/icons';
import * as S from './Warning.styled';
export const Warning = () => (React.createElement(S.WarningContainer, null,
    React.createElement(S.WarningContent, null,
        React.createElement(S.WarningIconWrapper, null,
            React.createElement(Icon, { component: ExclamationMarkIcon, height: 20 })),
        React.createElement(S.WarningText, null, "Never share your API credentials publicly or include them in custom HTML code. Exposing API keys in embedded code can lead to unauthorized access and misuse of your account."))));
